import React from 'react'
import PropTypes from 'prop-types'
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import { ToggleButtonGroup } from '@material-ui/lab'
import SegmentedToggleButton from 'components/segmented-toggle-button'
import LocationDropdown from 'pages/schedule/SelectLessonType/location-dropdown'
import CalendarDatePicker from './calendar-date-picker'
import {
  CALENDAR_VIEW_OPTIONS,
  MOBILE_CALENDAR_VIEW_OPTIONS,
  getMobileCalendarView,
  isViewingToday,
} from './calendar-utils'
import useCalendarStyles from './calendar-styles'

const CalendarToolbar = ({
  view,
  anchorDate,
  isMobile = false,
  onViewChange,
  onToday,
  onDateChange,
  selectedFacility,
  onSelectedFacilityChange,
  coachFacilities,
  hasOneLocation,
}) => {
  const classes = useCalendarStyles()
  const viewingToday = isViewingToday(view, anchorDate)
  const mobileView = getMobileCalendarView(view)
  const viewOptions = isMobile
    ? MOBILE_CALENDAR_VIEW_OPTIONS
    : CALENDAR_VIEW_OPTIONS
  const activeView = isMobile ? mobileView : view

  return (
    <Box className={classes.controlBar}>
      <Box className={classes.controlBarControls}>
        <Box className={classes.segmentControlWrapper}>
          <ToggleButtonGroup
            exclusive
            value={activeView}
            onChange={(_, nextView) => {
              if (nextView) {
                onViewChange(nextView)
              }
            }}
            className={`${classes.segmentControl} ${
              isMobile ? classes.mobileSegmentControl : ''
            }`}
            aria-label="Schedule view"
          >
            {viewOptions.map(option => (
              <SegmentedToggleButton
                key={option.value}
                value={option.value}
                groupValue={activeView}
                showCheck={false}
                data-cy={`schedule-view-${option.value}`}
                className={`${classes.segmentButton} ${
                  isMobile ? classes.mobileSegmentButton : ''
                }`}
              >
                {option.label}
              </SegmentedToggleButton>
            ))}
          </ToggleButtonGroup>
        </Box>
      </Box>

      <Box className={classes.toolbarFilters}>
        <Button
          variant="outlined"
          className={`${classes.todayButton} ${
            viewingToday ? classes.todayButtonSelected : ''
          }`}
          onClick={onToday}
          aria-pressed={viewingToday}
        >
          Today
        </Button>

        {!isMobile ? (
          <CalendarDatePicker
            anchorDate={anchorDate}
            onDateChange={onDateChange}
          />
        ) : null}

        {!hasOneLocation ? (
          <Box className={classes.locationWrapper}>
            <LocationDropdown
              selectedFacility={selectedFacility}
              setSelectedFacility={onSelectedFacilityChange}
              locations={coachFacilities}
              allOptionLabel="All Facilities"
              menuPaperClassName={classes.locationMenuPaper}
              classes={{
                formControl: classes.locationFormControl,
                outlinedInput: classes.locationOutlinedInput,
                notchedOutline: classes.locationNotchedOutline,
                select: classes.locationSelectInput,
                icon: classes.locationSelectIcon,
              }}
            />
          </Box>
        ) : null}
      </Box>
    </Box>
  )
}

CalendarToolbar.propTypes = {
  view: PropTypes.string.isRequired,
  anchorDate: PropTypes.object.isRequired,
  isMobile: PropTypes.bool,
  onViewChange: PropTypes.func.isRequired,
  onToday: PropTypes.func.isRequired,
  onDateChange: PropTypes.func.isRequired,
  selectedFacility: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  onSelectedFacilityChange: PropTypes.func.isRequired,
  coachFacilities: PropTypes.arrayOf(PropTypes.object).isRequired,
  hasOneLocation: PropTypes.bool.isRequired,
}

export default CalendarToolbar
